__webpack_require__.p = "https://bmidxbgermanyplpreprod.netlify.app/";